<template>
  <!-- FX Calculator -->
  <div>
    <div v-if="isExchangeView && minAmountForCommission > 0" class="card text-align-center align-items-center justify-content-space-between border-color-green pl-sm pr-sm" style="background-color: var(--f7-theme-color-10);">
      <p class="text-color-green b">{{ getMoreCommissionText }}</p>
    </div>

    <div class="card">
      <div v-if="isHomeView" class="card-header">{{$t('fx-label-calculator')}}</div>
      <div class="card-20">
        <div class="mb-md text-color-gray b">
            {{ $t('fx-label-exchange-rate') }}
            <span v-if="activeRate.isReverse" class="text-color-black">1 {{homeCurrency}}  =  {{activeRate.bidRateDisplay}} {{hostCurrency}}</span>
            <span v-else class="text-color-black">1 {{hostCurrency}}  =  {{activeRate.bidRateDisplay}} {{homeCurrency}}</span>
        </div>
        <f7-list class="form-group">

          <!-- HOST AMOUNT INPUT -->
          <f7-list-input
            :input-id      ="inputHostAmountID"
            :name          ="inputHostAmountID"
            type          ="text"
            class         ="amount fx-amount-row host-amount"
            placeholder   =""
            :label        ="$t('fx-label-you-send')"
            autocomplete  ="off"
            pattern       ="[0-9]*"
            inputmode     ="decimal"
            outline
            floating-label
            required

            :value            ="hostObj.amount == 0 ? '' : hostObj.amount"
            @blur             ="hostObj.amount = $event.target.value; hostObj.tempAmount != $event.target.value ? calcFXRate($event.target.id) : '' ; isNotFirstLoad = true"
            @focus            ="amountFocus($event.target.id); hostObj.tempAmount = hostObj.amount;"
            @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (hostObj.amount = $event.target.value, $event.target.blur()) : ''"
            @keydown.native   ="preventInvalidNumericInput($event)"
            >
            <div slot="media" class="currency-code">
              <img :src="getCircleSmallFlagImg(hostCountryId)" />
              {{hostCurrency}}
            </div>
          </f7-list-input>

          <!-- HOME AMOUNT INPUT -->
          <f7-list-input
            id            ="fxHomeAmountListId"
            :input-id      ="inputHomeAmountID"
            :name          ="inputHomeAmountID"
            type          ="text"
            class         ="amount fx-amount-row mb-22"
            placeholder   =""
            :label        ="$t('fx-label-recipient-receives')"
            autocomplete  ="off"
            pattern       ="[0-9]*"
            inputmode     ="decimal"
            outline
            floating-label
            required

            :value            ="homeObj.amount == 0 ? '' : homeObj.amount"
            @blur             ="homeObj.amount = $event.target.value; calcFXRate($event.target.id); isNotFirstLoad = true"
            @focus            ="amountFocus($event.target.id);"
            @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (homeObj.amount = $event.target.value, $event.target.blur()) : ''"
            @keydown.native   ="preventInvalidNumericInput($event)"
            >
            <f7-link id="fxHomeCountryCode" v-if="isHomeView || isExchangeView" popover-open=".popover-home-currency" class="row popover-fx-currency" slot="media">
              <div class="currency-code">
                <img :src="getCircleSmallFlagImg(homeCountryId)"  />
                {{homeCurrency}}
                <i class="f7-icons">chevron_down</i>
              </div>
            </f7-link>
          </f7-list-input>
          <li v-show="showHomeRoundedUpAmt" class="mb-md">
            <span class="text-color-gray fs-12">{{$t('sendmoney-enter-amount-roundup-amount-note')}}</span>
          </li>
          <f7-popover id="fxHomeAmountDropdown" class="popover-home-currency popover-fx-currency fx-calculator" :backdrop="true">
            <f7-list>
                <f7-list-item popover-close link="#" v-for="country in fxRateCountryList" :key="country.id" selected="99" @click="eventChangeHomeCountry(country.id)">
                  <img :src="getCircleSmallFlagImg(country.id)" class="mr-sm" />
                  {{ country.currencyCode }}
                </f7-list-item>
            </f7-list>
          </f7-popover>

          <!-- DELIVERY METHOD DROPDOWN -->
          <f7-list-input
            input-id     ="deliveryMethod"
            id           ="deliveryMethodInput"
            name         ="deliveryMethod"
            class        ="clickable-row use-chevron mb-md"
            :label       ="$t('fx-transfer-type')"
            :placeholder ="$t('fx-select-transfer-type')"
            :value       ="deliveryMethod"
            @change      ="deliveryMethodId = $event.target.value;"
            v-if         ="isExchangeView"
            outline
            floating-label
          >
            <f7-link popover-open=".popover-dropdown-delivery-method" slot="content-start" class="clickable-item"></f7-link>
          </f7-list-input>
          <f7-popover id="dropdownDeliveryMethod" class="popover-dropdown-delivery-method dropdown-default dropdown fx-calculator" :backdrop="true">
            <f7-list>
              <f7-list-item popover-close link="#" v-for="item in fxDeliveryMethodList" :key="item.key" :selected="item.key == deliveryMethodId" @click="handleChangeDeliveryMethod(item.key, false); handleChangeFXParamHandler();">
                {{$t('general-text-dm-'+item.key)}}
              </f7-list-item>
            </f7-list>
          </f7-popover>

          <!-- PAYMENT METHOD DROPDOWN-->
          <f7-list-input
            input-id     ="paymentMethod"
            id           ="paymentMethodInput"
            name         ="paymentMethod"
            class        ="clickable-row use-chevron"
            :label       ="$t('fx-payment-method')"
            :placeholder ="$t('fx-select-payment-method')"
            :value       ="paymentMethod"
            @change      ="paymentMethodId = $event.target.value;"
            v-if         ="isExchangeView"
            outline
            floating-label
          >
            <f7-link popover-open=".popover-payment-method" slot="content-start" class="clickable-item">
            </f7-link>
          </f7-list-input>
          <f7-popover id="dropdownPaymentMethod" class="popover-payment-method dropdown-with-image-1 dropdown fx-calculator" :backdrop="true">
            <f7-list>
              <f7-list-item  popover-close link="#" v-for="pm in paymentMethodList" :key="pm.id" :value="pm.id"  @click="eventChangePaymentMethod(pm.id)">
                <div class="row align-items-center" style="-webkit-flex-wrap: nowrap;">
                  <span class="fs-16">{{$t('sendmoney-pm-'+pm.id)}}</span>
                  <img :src="require('@/assets/img/paymentmethod/pm_'+pm.id+'.png')" class="ml-sm"/>
                </div>
              </f7-list-item>
            </f7-list>
          </f7-popover>

        </f7-list>

        <f7-button v-if="isHomeView" class="mt-20" large fill round @click="handleRedirectBtnDetail()" >
          {{$t('general-text-details')}}
        </f7-button>
      </div>
    </div>

    <div v-if="isExchangeView" class="card card-20 payment-summary">
      <div class="mb-20 wandr-level-3">{{$t('sendmoney-text-payment-summary')}}</div>
      <div class="payment-details">
        <div>
          <div>{{$t('sendmoney-text-commision')}}
            <f7-link popover-open=".popover-commision-info" class="info">
              <i class="icon f7-icons color-green pl-sm" id="infoCommisionIcon">icon_info_circle</i>
            </f7-link>
          </div>
          <div>{{this.formatCurrency(commissionAmount, 2) || 0}} {{hostCurrency}}</div>
        </div>
        <div>
          <div>{{$t('general-text-convenience-fee')}}</div>
          <div>{{this.formatCurrency(convenienceTotalFees, 2) || 0}} {{hostCurrency}}</div>
        </div>
        <div class="b">
          <div>{{$t('general-text-total-fee')}}</div>
          <div>{{this.formatCurrency((parseFloat(commissionAmount) + parseFloat(convenienceTotalFees)), 2) || 0}} {{hostCurrency}}</div>
        </div>
      </div>
      <div class="payment-details pt-sm">
        <div>
          <div :class="homeObj.amountReal.toString().length >= 7 ? 'title' : ''">{{$t('fx-total-amount')}}</div>
          <div>{{this.formatCurrency(hostObj.amountReal, 2) || 0}} {{hostCurrency}}</div>
        </div>
        <div>
          <div :class="homeObj.amountReal.toString().length >= 7 ? 'title' : ''">{{$t('fx-guaranteed-rate')}}</div>
          <div>{{this.formatCurrency(homeObj.amountReal, 2) || 0}} {{homeCurrency}}</div>
        </div>
      </div>
      <div class="payment-total" v-if="deliveryTimeType.length > 0">
        <div>{{$t('fx-should-arrive')}}</div>
        <div>{{ deliveryTimeNumber }} {{ deliveryTimeType }}</div>
      </div>
    </div>
    <f7-popover class="popover-commision-info info" :backdrop="true">
        <div class="fs-10 fw-medium">
          {{$t('sendmoney-text-commission')}}
        </div>
    </f7-popover>

    <div v-if="isExchangeView" class="mt-xxl">
      <f7-button :disabled="isFormInputValid ? false : true" large fill round @click="handleRedirectBtnSendMoney()">{{$t('general-btn-send-money')}}</f7-button>
    </div>
  </div>

</template>

<script>
  import { check, enforce, fxRateHelper as FX }  from '@/plugins/helper'
  import { mapActions } from "vuex"

  export default{
    name  : "ExchangeRateCalculator",
    props : {
      isHomeView      : { required: false },
      isExchangeView  : { required: false },
      keepLoading     : { required: false }
    },
    components: {
      
    },
    data(){
      return {
        activeRate        : { bidRate : 0, bidRateDisplay : "0", isReverse: false },
        alertCard         : { show : false, title : "errror", content : "", alertClass : "alert-danger" },
        bankTypeId        : 1,
        commissionAmount  : 0, // for charge.
        convenienceFee    : 0,
        convenienceFeeByPercentage : 0,
        convenienceTotalFees : 0,
        couponCode        : "",
        deliveryMethodId  : 0,
        deliveryMethod    : "",
        deliveryTimeList  : [],
        deliveryTimeNumber: '',
        deliveryTimeType  : '-',
        expressAvailable  : false,
        expressService    : 0,
        fxDeliveryMethodList: [],
        fxRateCountryList : [],
        fxRateObject      : { fxRateList : {} },
        homeCountryName   : "Indonesia",
        homeCountryId     : 99,
        homeCurrency      : "IDR",
        homeObj           : { amount : "", amountReal : 0, isFocused : false },
        hostCountryId     : 189,
        hostCurrency      : "SGD",
        hostObj           : { amount : "", amountReal : 0, isFocused : false, tempAmount : "" },
        isFormInputValid  : false,
        isExpressBankType : false,
        isNotFirstLoad    : false,
        inputHostAmountID : "",
        inputHomeAmountID : "",
        latestState       : "",
        maxOutstandingAmt : 10000,
        maxTotalSendingAmount : 10000,
        minHostAmount     : 0,
        minOutstandingAmt : 0,
        paymentMethod     : "",
        paymentMethodId   : 0,
        paymentMethodList : [],
        p2hCustomerId     : 0,
        showHomeRoundedUpAmt : false,
        totalPayable      : 0,
        totalUnclearAmount : 0,
        treasuryReceiptAmountLimit: 10000,
        needToPopulateRate : false,
        tempHomeCountryId  : 99,
        getMoreCommissionText     : "",
        minAmountForCommission    : 0
      }
    },
    mounted(){
      this.inputHostAmountID = (this.isHomeView) ? "fx-host-amount" : "fx-calc-host-amount"
      this.inputHomeAmountID = (this.isHomeView) ? "fx-home-amount" : "fx-calc-home-amount"

      this.p2hCustomerId = this.$store.state.customer.customerId
      this.homeCountryId = this.$store.state.transaction.homeCountryId
      this.homeCountryName = this.$store.state.transaction.homeCountryName
      this.homeCurrency  = this.$store.state.transaction.homeCurrency
      this.hostCountryId = this.$store.state.transaction.hostCountryId
      this.hostCurrency  = this.$store.state.transaction.hostCurrency
      this.deliveryMethodId = this.$store.state.transaction.deliveryMethodId
      this.deliveryMethod = this.$store.state.transaction.deliveryMethod
      this.bankTypeId = this.$store.state.transaction.bankTypeId
      this.hostObj.amount = this.$store.state.transaction.hostAmountReal
      this.homeObj.amount = this.$store.state.transaction.homeAmountReal
      this.totalUnclearAmount = this.$store.state.customer.totalUnclearAmount
      this.minOutstandingAmt = this.$store.state.customer.minOutstandingAmt
      this.maxOutstandingAmt = this.$store.state.customer.maxOutstandingAmt
      this.paymentMethod = this.$store.state.transaction.paymentMethod
      this.paymentMethodId = this.$store.state.transaction.paymentMethodId
      this.transactionTypeId = this.$store.state.transaction.transactionTypeId
      this.treasuryReceiptAmountLimit = ( this.$store.state.misc.appBranchId == process.env.VUE_APP_RETAIL_BRANCH_ID ) ?  this.$store.state.customer.treasuryReceiptAmountLimit : this.$store.state.customer.onlineTreasuryReceiptAmountLimit
      this.maxTotalSendingAmount = this.maxOutstandingAmt - this.totalUnclearAmount
      this.expressService = 1
      this.expressAvailable = false

      this.$store.state.beneficiary.routerTo = ""
      this.setInputState(this.inputHostAmountID, true)
      this.setInputState(this.inputHomeAmountID, true)

      this.hostCountryId = 189
      this.hostCurrency  = "SGD"

      if(this.homeCountryId == 0 || this.hostObj.amount == 0 || this.isHomeView){
        this.homeCountryId = 99
        this.homeCurrency  = "IDR"

        if(this.hostObj.amount <= 0 || this.isHomeView){
          this.hostObj.amount     = 1
          this.hostObj.amountReal = 1
          this.latestState        = "host"
        }
      }

      if(this.homeCountryId == 99 && this.$store.state.transaction.FxRateDefaultHomeCountry != undefined && this.homeCountryId == this.$store.state.transaction.FxRateDefaultHomeCountry.currencyId){
        this.activeRate = this.$store.state.transaction.FxRateDefaultHomeCountry
      }else if(this.$store.state.transaction.FxRateHomeCountry != undefined && this.homeCountryId == this.$store.state.transaction.FxRateHomeCountry.currencyId){
        this.activeRate = this.$store.state.transaction.FxRateHomeCountry
      }

      if(this.homeCountryId == 44){
        this.showHomeRoundedUpAmt = true
      }

      if(this.isHomeView || this.isExchangeView){
        this.getDeliveryMethodList(this.homeCountryId, false)
      }

      this.getMinHostAmount()
      this.getHelpText(51, 0)

      if(this.isHomeView || this.isExchangeView){
        this.getFxRate()
        this.renderCalculatorDropdown()
      }

      this.hostObj.tempAmount = this.hostObj.amount
      this.tempHomeCountryId = this.$store.state.customer.lastFxCalcCurrencyId
    },
    methods : {
      ...mapActions('customer', [ 'setLastFxCalcCurrencyId' ]),

      getMinHostAmountForMoreCommission(){
        const self = this;
        const destCountryId = self.homeCountryId;
        let txMinAmount = 0;

        // 13 - AUSTRALIA
        if(destCountryId == 13){
          txMinAmount = 10000
        }
        // 152 - NEW ZEALAND
        else if(destCountryId == 152){
          txMinAmount = 3000
        }
        // 208 - THAILAND
        else if(destCountryId == 208){
          txMinAmount = 3500
        }
        // 98 - INDIA
        else if(destCountryId == 98){
          txMinAmount = 2000
        }
        // 99 - INDONESIA
        else if(destCountryId == 99){
          txMinAmount = 1000
        }
        // 167 - PHILIPPINES
        else if(destCountryId == 167){
          txMinAmount = 1000
        }
        // 106 - JAPAN
        else if(destCountryId == 106){
          txMinAmount = 3000
        }
        // 111 - S. KOREA
        else if(destCountryId == 111){
          txMinAmount = 2000
        }
        // 95 - HONG KONG
        else if(destCountryId == 95){
          txMinAmount = 3000
        }
        // 197 - SRI LANKA
        else if(destCountryId == 197){
          txMinAmount = 3000
        }
        //Malaysia
        else if(destCountryId==128){
          txMinAmount = 1500
        }
        //Vietnam
        else if(destCountryId==228){
          txMinAmount = 1000
        }
        //China || Taiwan
        else if(destCountryId==44 || destCountryId == 205){
          txMinAmount = 1500
        }
        //United Kingdom (UK)
        else if(destCountryId==221){
          txMinAmount = 3000
        }
        //United State (USA)
        else if(destCountryId==253){
          txMinAmount = 3500
        }
        //European Union (EU)
        else if(destCountryId==238){
          txMinAmount = 3000
        }
        self.minAmountForCommission = txMinAmount
        txMinAmount = self.formatCurrency(txMinAmount, 2)

        let tmpDestinationName = self.homeCountryName;
        if(destCountryId==253){ // USA -> country name returned by API = "America"
          tmpDestinationName = "the United States";
        }else if(destCountryId==238){ // EU -> country name returned by API = "European Union (EU)"
          tmpDestinationName = "EU";
        }else if(destCountryId==167 || destCountryId==221){ // Philippines || United Kingdom (UK)
          tmpDestinationName = "the "+self.homeCountryName;
        }
        self.getMoreCommissionText = self.$t('sendmoney-more-commisions-text', { minamount:  txMinAmount, destination: tmpDestinationName })        
      },

      async renderDropdown(){
        const self = this;
        const popover1 = ".fx-calculator.popover-dropdown-delivery-method";
        const popoverInner1 = ".fx-calculator.popover-dropdown-delivery-method .popover-inner";
        const popoverId1 = "dropdownDeliveryMethod";
        const inputId1 = "deliveryMethod";
        const inputListId1 = "#deliveryMethodInput";
        await self.setDropdownDirection(popover1, popoverInner1, popoverId1, inputId1, inputListId1)

        const popover2 = ".fx-calculator.popover-payment-method";
        const popoverInner2 = ".fx-calculator.popover-payment-method .popover-inner";
        const popoverId2 = "dropdownPaymentMethod";
        const inputId2 = "paymentMethod";
        const inputListId2 = "#paymentMethodInput";
        await self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2)

        
        self.Dom7(".popover-commision-info.info").on('popover:open', function () {
            self.$$(".popover-commision-info.info").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7(".popover-commision-info.info").on('popover:opened', async function () {
            const parentPosTop = parseFloat(document.getElementById("infoCommisionIcon").getBoundingClientRect().top);
            const parentPosLeft = parseFloat(document.getElementById("infoCommisionIcon").getBoundingClientRect().left);

            var elHeight = parseFloat(self.$$(".popover-commision-info.info.popover.modal-in").height());

            self.$$(".popover.info.modal-in .popover-angle").css({
                'margin-left' : (-9.00 / 2) + 'rem', // 8rem = popover width, 1rem = 16px = margin
                'top' : (elHeight/2) + 'px',
                'transform' : 'rotate(90deg)'
            });

            self.$$(".popover-commision-info.info.modal-in").css({
                'visibility' : 'visible',
                'left' : (parentPosLeft+40) + 'px',
                'top' : (parentPosTop-16) + 'px'
            });

            // CLOSE POP-UP AFTER 3 SECONDS
            setTimeout(function(){
              self.$f7.popover.close('.popover-commision-info.info.modal-in')
            }, 3000);

        });

      },

      async renderCalculatorDropdown(){
        const self = this;
        const popover3 = ".fx-calculator.popover-home-currency";
        const popoverInner3 = ".fx-calculator.popover-home-currency .popover-inner";
        const popoverId3 = "fxHomeAmountDropdown";
        const inputId3 = self.inputHomeAmountID;
        const inputListId3 = "#fxHomeAmountListId";
        await self.setDropdownDirection(popover3, popoverInner3, popoverId3, inputId3, inputListId3, "fx-calculator", "fxHomeCountryCode")
      },

      // FX RATE DETAIL HANDLE
      getExpressMapping(){
        const self = this;
        self.showPreloader();
        const txExpressMapping = this.$api.transaction.getExpressMapping(self.deliveryMethodId, self.bankId, self.homeCountryId, self.expressService);
        txExpressMapping.then(function(result) {
          self.bankExpressId = result.bankId;
          var transactionData = self.$store.state.transaction;
          if(result.expressAvailable){
            transactionData.expressAvailable = 1;
            self.expressAvailable = true
          }

          self.getFxRate()
        });
      },

      getFxRate(){
        const self = this;
        self.showPreloader();

        const fxRateListPromise    = this.$api.exchangeRate.getFXRateList(-1, 0, self.p2hCustomerId)
        const fxCountryListPromise = this.$api.exchangeRate.getFxCountryList()

        Promise.all([fxRateListPromise, fxCountryListPromise]).then((response)=>{
          const fxRateList    = response[0]
          const fxCountryList = response[1]

          // if(self.isHomeView){
          //   self.$emit('setIsCountryPopulated', true)
          // }

          this.$_.each(fxRateList, (fxRate) => {
            if(fxRate.currency == this.homeCurrency && fxRate.deliveryMethodId == this.deliveryMethodId){
              self.bankTypeId     = fxRate.bankTypeId;
              var transactionData = this.$store.state.transaction;
              transactionData.bankTypeId = fxRate.bankTypeId;
              if(fxRate.bankTypeId == 2){
                self.isExpressBankType = true
                transactionData.isExpressBankType = 1
              }
            }
          })

          self.fxRateObject.fxRateList = FX.buildRateList(fxRateList)
          self.fxRateCountryList       = FX.rearrageCountryList(fxCountryList, fxRateList)

          if(self.isExchangeView || self.isHomeView){
            /* WA-396 */            
            const nationalityId = self.$store.state.customer.nationalityId
            const lastFxCalcCurrencyId = parseInt(self.$store.state.customer.lastFxCalcCurrencyId)
            const arrTxDestList = self.$store.state.customer.txDestList

            const valObj = self.fxRateCountryList.filter(function(elem){
                if(elem.id == nationalityId) return elem.id;
            });

            // NEVER USED FX CALCULATOR OR HAS NO TRANSACTION YET
            if(lastFxCalcCurrencyId === 0){
              // 0 - NOT SET (NEW ACCOUNT) || 189 - SINGAPOREAN
              if(nationalityId == 0 || nationalityId == 189){
                self.homeCountryId = self.fxRateCountryList[0].id // AUD
              }else{
                if(valObj.length > 0){
                  self.homeCountryId = nationalityId
                }else{ // NOT IN THE DEST COUNTRY LIST
                  self.homeCountryId = self.fxRateCountryList[0].id //AUD
                }
              }
            }else{
              const valObj2 = self.fxRateCountryList.filter(function(elem){
                  if(elem.id == lastFxCalcCurrencyId) return elem.id;
              });
              
              if(lastFxCalcCurrencyId == "189"){
                self.homeCountryId = self.fxRateCountryList[0].id //AUD
              }else{
                if(valObj2.length > 0){
                  self.homeCountryId = lastFxCalcCurrencyId
                }else{ // NOT IN THE DEST COUNTRY LIST
                  self.homeCountryId = self.fxRateCountryList[0].id //AUD
                }
              }
            }

            // RE-ARRANGE ORDER OF CURRENCIES
            self.fxRateCountryList.forEach(function(item, i){
              arrTxDestList.forEach(function(item2){
                if(item2 === item.id){
                  self.fxRateCountryList.splice(i, 1);
                  self.fxRateCountryList.unshift(item);
                }
              })
            });

            self.fxRateCountryList.forEach(function(item, i){
              if(item.id === self.homeCountryId){
                self.fxRateCountryList.splice(i, 1);
                self.fxRateCountryList.unshift(item);
              }
            });

            //console.log("called from : getFXrate")
            //self.updateLastFxCalcCurrencyId(self.homeCountryId)

            /* END OF WA-396 */
            self.populateCountryDetail(self.homeCountryId)
          }

          self.activeRate = self.populateActiveRate()
          self.calcFXRate()
        })
      },

      populateActiveRate(){
        let list = this.fxRateObject.fxRateList || {}
        let homeCountryDetails = {
          countryId : this.homeCountryId,
          dmId      : (this.deliveryMethodId == 7 || this.deliveryMethodId == 8) ? 1 : this.deliveryMethodId,
          bankTypeId: (this.bankTypeId > 0) ? this.bankTypeId : 1
        }

        let newList = FX.getFxRateFromList(list, {countryId: this.hostCountryId}, homeCountryDetails)
        this.needToPopulateRate = check.isEmptyObject(newList)
        if ( newList !== undefined ) {
          if(newList.baseCurrencyIdOriginal != undefined && newList.baseCurrencyIdOriginal != 189){
            newList.bidRateDisplay = FX.formatDisplayRate(newList.bidRateOriginal, {countryId: this.homeCountryId, isDisplay: true})
          }else{
            newList.bidRateDisplay = FX.formatDisplayRate(newList.bidRate, {countryId: this.homeCountryId, isDisplay: true})
          }

          // Reverse for AUD NZD GBP EUR USD
          newList.isReverse = (this.homeCountryId == 152 || this.homeCountryId == 13 || this.homeCountryId == 221 || this.homeCountryId == 238 || this.homeCountryId == 253) ? true : false
        }
        this.$store.state.transaction.FxRateHomeCountry = newList
        if(this.homeCountryId == 99){
          this.$store.state.transaction.FxRateDefaultHomeCountry = newList
        }
        return newList
      },

      async calcFXRate(){
        const self             = this
        self.hostObj.isFocused = false
        self.homeObj.isFocused = false
        let isHost             = ""
        let args               = arguments

        if(typeof args[0] == 'string'){
          isHost = args[0] == self.inputHostAmountID ? true : false ;
        } else if (typeof args[0] == 'boolean'){
          isHost = args[0]
          if(isHost){
            self.latestState = "host"
          }else{
            self.latestState = "home"
          }
        }

        if(!isHost || self.latestState != "host"){
          if(self.homeObj.amount == null){
            isHost= true
          }
        }

        if ( isHost || self.latestState == "host") {
        
          self.hostObj.amount = parseFloat(self.hostObj.amount.toString().replace(/,/g, ''))
          self.hostObj.amount = enforce.maxLength(self.hostObj.amount, 10)
          self.hostObj.amount = enforce.maxAmount(self.hostObj.amount, 1000000)

          self.hostObj.amountReal = FX.formatCurrency(parseFloat(self.hostObj.amount)) || 0
          self.homeObj.amountReal = FX.formatCurrency(self.hostObj.amount * self.activeRate.bidRate, {countryId: self.activeRate.currencyId})

        } else {

          self.homeObj.amount = parseFloat(self.homeObj.amount.toString().replace(/,/g, ''))
          self.homeObj.amount = enforce.maxLength(self.homeObj.amount, 14)

          // if((self.homeObj.amount / self.activeRate.bidRate) > 100000) {
          //   self.homeObj.amount = 100000 * self.activeRate.bidRate;
          // }

          self.homeObj.amountReal = FX.formatCurrency(parseFloat(self.homeObj.amount), {countryId: self.activeRate.currencyId}) || 0
          self.hostObj.amountReal = FX.formatCurrency(self.homeObj.amountReal / self.activeRate.bidRate)
        }

        //DO ROUNDING UP FOR CN DESTINATION COUNTRY
        if(self.homeCountryId == 44){
          self.homeObj.amountReal = FX.formatCurrency( Math.round(parseFloat(self.homeObj.amountReal)), {countryId: self.activeRate.currencyId}) || 0
          self.hostObj.amountReal = FX.formatCurrency(self.homeObj.amountReal / self.activeRate.bidRate)
        }

        self.formatAmount()
        console.log("called from : calcFXRate")
        await self.updateLastFxCalcCurrencyId(self.homeCountryId)
        await self.getMinHostAmountForMoreCommission()
      },

      formatAmount(){
        const self = this;

        self.$$('.fx-amount-row input').attr('type', 'text')

        if(self.$f7.device.ios && typeof arguments[0] == 'string'){
          self.calcFXRate(arguments[0])
        }

        self.hostObj.amount = self.hostObj.amountReal == 0 ? "" : FX.formatCurrency(self.hostObj.amountReal, {isDisplay: true})
        self.homeObj.amount = self.homeObj.amountReal == 0 ? "" : FX.formatCurrency(self.homeObj.amountReal, {countryId: self.activeRate.currencyId, isDisplay: true})

        if(this.isHomeView){ // SKIP NEXT STEP FOR HOME VIEW ONLY
          //console.log("SKIP NEXT STEP FOR HOME VIEW ONLY")
          if(self.isHomeView){
            self.$emit('setIsCountryPopulated', true)
          }
          if (!this.keepLoading) { self.hidePreloader() }
          return
        }

        self.handleCalculateFees()
      },

      handleCalculateFees(){
        const self = this
        var bankIdUsed = (self.expressAvailable) ? self.bankExpressId : self.bankId
        let dmId = (self.deliveryMethodId == 7 || self.deliveryMethodId == 8) ? 1 : self.deliveryMethodId
        let transactionTypeId = ( dmId == 0) ? 1:2

        const txSpecialChargePromise = this.$api.transaction.getSpecialCharge(dmId, self.homeCountryId)
        const txChargePromise        = this.$api.transaction.getCharge(self.homeCountryId, dmId, bankIdUsed, self.bankBranchId, self.homeCountryId, transactionTypeId, self.couponCode, self.provinceId, self.cityId, self.hostObj.amountReal)

        Promise.all([txSpecialChargePromise, txChargePromise]).then((response)=>{

          const txSpecialCharge = response[0]
          const txCharge        = response[1]

          if(txSpecialCharge.status == "2100" && txCharge.status == "1401"){
            const amountCharge = txCharge.result.amount;

            if(txSpecialCharge.result.minCharge > 0){
              self.isSpecialCharge      = true;
              self.specialChargePercent = txSpecialCharge.result.percentage;
              self.specialChargeMin     = txSpecialCharge.result.minCharge;
            }else{
              self.charge = (amountCharge > 0) ?  amountCharge : 0
            }

            if(self.isSpecialCharge){
              const percentageFees = (self.specialChargePercent / 100) * self.hostObj.amountReal;
              self.commissionAmount = (self.specialChargeMin > percentageFees) ?  (self.specialChargeMin).toFixed(2) :  (percentageFees).toFixed(2)
            }else{
              self.commissionAmount   = (self.charge).toFixed(2);
            }

            self.handleCalculatePayment()

          }else{//show general error
            self.showErrorCard(self.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            self.hidePreloader();
          }
        })
      },

      handleCalculatePayment(){
        if(this.$$("#"+this.inputHostAmountID).is(':focus')){
          this.amountFocus(this.inputHostAmountID)
        }
        if(this.$$("#"+this.inputHomeAmountID).is(':focus')){
          this.amountFocus(this.inputHomeAmountID)
        }
        var remittanceAmount = parseFloat(this.hostObj.amountReal)
        var isValidInput  = false
        this.totalPayable = (remittanceAmount + parseFloat(this.commissionAmount) ).toFixed(2)
        this.getPaymentMethod()
        this.setInputState(this.inputHomeAmountID, true)
        this.setInputState(this.inputHostAmountID, true)

        if(remittanceAmount >= this.minHostAmount){
          if(remittanceAmount > parseFloat(this.treasuryReceiptAmountLimit)){
            this.setInputState(this.inputHostAmountID, this.$t('sendmoney-limit-amount-alert-content-1', {zoholink: process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK, currency:this.hostCurrency, amount: this.formatCurrency(this.treasuryReceiptAmountLimit, 2)}))
            isValidInput = false
          }else{
            if(remittanceAmount == 0){
              isValidInput = false
            }else if(remittanceAmount > parseFloat(this.maxTotalSendingAmount)){
              this.setInputState(this.inputHostAmountID, this.$t('sendmoney-limit-amount-alert-content-2', {zoholink: process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}))
              isValidInput = false
            }else if(this.validateHomeAmountOverlimit()){
              isValidInput = false
            }else{
              this.alertCard.show = false
              isValidInput = true
            }
          }
        }else{
          // if(remittanceAmount > 0 && remittanceAmount < this.minHostAmount && this.isNotFirstLoad){ // FLAG FOR NOT DISPLAY ERROR MIN AMOUNT ON FIRST LOAD
          if(remittanceAmount > 0 && remittanceAmount < this.minHostAmount){
            this.setInputState(this.inputHostAmountID, this.$t('sendmoney-enter-amount-min-amount', {currency: this.hostCurrency, amount: this.formatCurrency(this.minHostAmount, 2)}))
            isValidInput = false
          }else{
            this.alertCard.show = false
            isValidInput = false
          }
        }

        if (remittanceAmount > 0 && this.validateHomeAmountUnderMinimum()) {
          isValidInput = false
        }

        this.populateDeliveryTime()
        this.isFormInputValid = isValidInput
        this.hidePreloader()
      },

      //EVENT HANDLE HOME COUNTRY HANDLE
      eventChangeHomeCountry(countryId) {
        let self = this
        self.showPreloader()
        // Harcode check BASECURRENCY OTHER THAN 189 SGD for WandrE V1.0 to display AUD/NZD/GBP/EUR/USD -> SGD
        self.activeRate.isReverse = (countryId == 152 || countryId == 13  || countryId == 221 || countryId == 238 || countryId == 253) ? true : false


        self.bankId = 0
        self.bankBranchId = 0
        self.provinceId = 0
        self.cityId     = 0
        self.setInputState(self.inputHomeAmountID,true)
        self.commissionAmount = (0).toFixed(2)
        self.populateCountryDetail(countryId)
        self.getDeliveryMethodList(countryId, true)
        //self.updateLastFxCalcCurrencyId(countryId) /* WA-396 */
        
        this.showHomeRoundedUpAmt = (this.homeCountryId == 44) ? true :false
      },

      populateCountryDetail(countryId){
        const self = this
        for (let i = 0; i < self.fxRateCountryList.length; i++ ) {
          if (self.fxRateCountryList[i].id == countryId) {
            self.homeCountryId   = self.fxRateCountryList[i].id
            self.homeCurrency    = self.fxRateCountryList[i].currencyCode
            self.homeCountryName = self.fxRateCountryList[i].name
            break
          }
        }
      },

      handleChangeFXParamHandler(){
        const self = this
        self.showPreloader()
        self.activeRate = self.populateActiveRate()
        const lastFxCalcCurrencyId = parseInt(self.$store.state.customer.lastFxCalcCurrencyId)
        console.log(lastFxCalcCurrencyId +" ### "+ self.homeCountryId)
        if(self.hostObj.tempAmount != self.hostObj.amount || lastFxCalcCurrencyId != self.homeCountryId){
          console.log("handleChangeFXParamHandler : RECALC")
          self.calcFXRate(true)
        }else{
          console.log("handleChangeFXParamHandler : NOT RECALC")
          self.hidePreloader()
        }
      },

      // DELIVERY METHOD HANDLE
      getDeliveryMethodList(countryId, executeChangeFxParam){
        console.log("-- LOAD DELIVERY METHOD LIST")
        let self = this;
        const fxDeliveryMethodListPromise = this.$api.exchangeRate.getDeliveryMethodList(countryId)
        fxDeliveryMethodListPromise.then((dmList)=>{
          self.fxDeliveryMethodList = []
          for (let key in dmList ){
            if( (countryId == 95 && key == 3) || ( countryId == 236 && key == 1 ) || ( countryId == 208 && key == 3 )  ){
              continue
            }else{
              self.fxDeliveryMethodList.push({key: key, value: dmList[key]})
            }
          }

          if (countryId == 99 || countryId == 167) {
            self.fxDeliveryMethodList.push({key: 7, value: self.$t('general-text-dm-7')})
          }
          if (countryId == 167) {
            self.fxDeliveryMethodList.push({key: 8, value: self.$t('general-text-dm-phil-gov')})
          }

          self.deliveryMethodId   = 1
          self.handleChangeDeliveryMethod(self.deliveryMethodId, executeChangeFxParam)
        })
      },

      handleChangeDeliveryMethod(dmId, executeChangeFxParam){
        this.getBankIdRandomly(dmId)
        for(let i=0; i < this.fxDeliveryMethodList.length; i++) {
          let thisDM = this.fxDeliveryMethodList[i]
          if(thisDM.key == dmId) {
            this.deliveryMethod   = this.$t('general-text-dm-' + dmId)
            this.deliveryMethodId = dmId
            break;
          }
        }
        if(executeChangeFxParam){
          this.handleChangeFXParamHandler()
        } else if(this.needToPopulateRate) {
          this.activeRate = this.populateActiveRate()
          this.calcFXRate()
        }
      },

      // PAYMENT METHOD HANDLE
      eventChangePaymentMethod(pmId){
        this.setInputState("paymentMethod", true)
        this.paymentMethodId = pmId
        this.getPaymentMethod()
      },

      getPaymentMethod(){
        const self = this
        const txPaymentMethod = this.$api.transaction.getPaymentMethodList(self.totalPayable)
        txPaymentMethod.then(function(result) {
          self.paymentMethodList = [];
          Object.keys(result).forEach(function(key) {
            var val = result[key];
            var item =[];
            item["id"]              = key
            item["name"]            = val.name
            item["fee"]             = val.fee
            item["feeByPercentage"] = val.feeByPercentage
            item["totalPayable"]    = val.totalAmountPayable
            item["totalFee"]        = val.totalFee
            item["priority"]        = val.priority

            self.paymentMethodList.push(item)
            if(self.paymentMethodId == key){
              self.paymentMethod   = self.$t('sendmoney-pm-'+ key)
              self.paymentMethodId = key
              self.convenienceFee  = val.fee
              self.convenienceFeeByPercentage = val.feeByPercentage
              self.convenienceTotalFees = val.totalFee
            }
          })

          self.paymentMethodList = self.paymentMethodList.sort((a,b)=> a.priority - b.priority)
        })

        self.renderDropdown();
      },

      validatePaymentMethod(){
        let pmId = this.paymentMethodId
        let isValidInput = false

        if(pmId <= 0){
          this.setInputState("paymentMethod", this.$t('fx-payment-method-error'))
          isValidInput =  false
        }else{
          this.setInputState("paymentMethod", true)
          isValidInput =  true
        }

        return isValidInput
      },

      validateHomeAmountOverlimit(){
        const self = this
        let isOverLimit = false
        let maxOverLimitAmount = 0
        let homeAmount = parseFloat(self.homeObj.amountReal)

        if(self.deliveryMethodId == 1 || self.deliveryMethodId == 9 ){
          if(self.homeCountryId == 98 && self.isExpressBankType == 1 &&  homeAmount > 200000 ){
            maxOverLimitAmount = 200000
            isOverLimit = true
          }
        }

        if(self.deliveryMethodId == 3){
          if(self.homeCountryId == 167 && ( self.bankId ==1105 || self.bankId == 3713 ) && homeAmount > 50000 ){
            maxOverLimitAmount = 50000
            isOverLimit = true
          }else if(self.homeCountryId == 167 && self.bankId ==2200 && homeAmount > 20000 ){
            maxOverLimitAmount = 20000
            isOverLimit = true
          }
        }

        if(isOverLimit){
          self.setInputState(self.inputHomeAmountID, self.$t('sendmoney-limit-amount-alert-content', {currency:this.homeCurrency, amount: this.formatCurrency(maxOverLimitAmount, 2)}))
        }

        return isOverLimit
      },

      validateHomeAmountUnderMinimum(){
        const self = this
        let isUnderMinimum = false
        let minimumAmount = 0
        let homeAmount = parseFloat(self.homeObj.amountReal)

        if(self.deliveryMethodId == 1){
          if(self.homeCountryId == 111 && homeAmount < 30000 ){ // South Korea
            minimumAmount = 30000
            isUnderMinimum = true
          }
        }

        if(isUnderMinimum){
          self.setInputState(self.inputHomeAmountID, self.$t('sendmoney-enter-amount-min-amount', {currency:this.homeCurrency, amount: this.formatCurrency(minimumAmount, 2)}))
        }

        return isUnderMinimum
      },

      // GENERAL BUTTON REDIRECT HANDLE
      handleRedirectBtnDetail(){
        this.showPreloader()

        var transactionData = this.$store.state.transaction
        transactionData.hostAmount = this.hostObj.amount
        transactionData.homeAmount = this.homeObj.amount
        transactionData.hostAmountReal = this.hostObj.amountReal
        transactionData.homeAmountReal = this.homeObj.amountReal
        transactionData.latestState = this.latestState
        transactionData.hostCountryId = this.hostCountryId
        transactionData.homeCountryId = this.homeCountryId
        transactionData.homeCurrency = this.homeCurrency
        transactionData.hostCurrency = this.hostCurrency
        transactionData.activeBidRate = this.activeRate.bidRate

        transactionData.paymentMethod =  ""
        transactionData.paymentMethodId = 0

        this.$f7router.navigate("/exchangerate")
        this.hidePreloader()
      },

      handleRedirectBtnSendMoney(){
        this.showPreloader()

        if( !this.validatePaymentMethod()){
          this.hidePreloader();
          return;
        }

        var transactionData = this.$store.state.transaction
        transactionData.hostAmount     = this.hostObj.amount
        transactionData.homeAmount     = this.homeObj.amount
        transactionData.hostAmountReal = this.hostObj.amountReal
        transactionData.homeAmountReal = this.homeObj.amountReal
        transactionData.homeCountryId  = this.homeCountryId
        transactionData.latestState    = this.latestState
        transactionData.deliveryMethod = this.deliveryMethod
        transactionData.deliveryMethodId = this.deliveryMethodId
        transactionData.paymentMethod = this.paymentMethod
        transactionData.paymentMethodId = this.paymentMethodId
        transactionData.convenienceFee = this.convenienceFee
        transactionData.convenienceFeeByPercentage  = this.convenienceFeeByPercentage
        transactionData.convenienceTotalFees = this.convenienceTotalFees
        transactionData.commissionAmount = this.commissionAmount
        transactionData.activeBidRate = this.activeRate.bidRate
        transactionData.bankExpressId = this.bankExpressId
        transactionData.totalAmountPaid = this.totalPayable
        transactionData.isMakePayment = false;

        this.$store.state.beneficiary.routerTo = "fxcalculator"
        this.$f7router.navigate("/sendmoney/select-beneficiary")
        this.hidePreloader()
      },

      amountFocus(thisDOMId){
        let isHost     = thisDOMId == this.inputHostAmountID ? true : false ;
        let $thisInput = this.$$('#'+thisDOMId);
        if( isHost ){
          this.latestState = "host";
          this.hostObj.isFocused = true;
          this.homeObj.isFocused = false;
          this.hostObj.amount = this.hostObj.amountReal == 0 ? "" : this.hostObj.amountReal

        } else {
          this.latestState = "home";
          this.homeObj.isFocused = true;
          this.hostObj.isFocused = false;
          this.homeObj.amount = this.homeObj.amountReal == 0 ? "" : this.homeObj.amountReal
        }

        $thisInput.attr('type', 'number');

        this.isFormInputValid = false;
      },

      getMinHostAmount(){
        const self = this
        const txMinHostAmount = this.$api.transaction.getMinHostAmount()
        txMinHostAmount.then(function(result) {
          self.minHostAmount = result.amount
        });
      },

      getHelpText(startId, endId){
        const self = this
        const getHelpTextRespon = self.$api.staticData.getHelpText(startId, endId);

        getHelpTextRespon.then(function(result) {
          if(result.length > 0){
            self.$store.state.transaction.paymentTime = result[0].content[0].value
          }
        })
      },

      getBankIdRandomly(dmId){
        const self = this
        const staticBankId       = []
        const staticBankBranchId = []
        self.provinceId = 0
        self.cityId     = 0
        self.bankId = 0
        self.bankBranchId = 0

        const indexTemp = self.hostCountryId + "-" +dmId+ "-" + self.homeCountryId
        //THB
        staticBankId['189-1-208']  = 184 // Bangkok Bank
        staticBankBranchId['189-1-208']  = 55833

        // AUD Bill Payment
        staticBankId['189-0-13']  = 555 //1 WORLD TELECOM
        staticBankBranchId['189-0-13']  = 0

        //IDR BT-Collection
        staticBankId['189-1-99']  = 2003 // BNI
        staticBankBranchId['189-1-99']  = 48042

        staticBankId['189-3-99']  = 2004 // PT Pos Indonesia Collection
        staticBankBranchId['189-3-99']  = 48054

        // IDR Wallet
        staticBankId['189-7-99']  = 4910
        staticBankBranchId['189-1-99']  = 0

        //PHP BT-Collection
        staticBankId['189-1-167']  = 3 // BANCO DE ORO (Metro Manila)
        staticBankBranchId['189-1-167']  = 3781

        staticBankId['189-3-167']  = 1105 //MLHullier Branch(Max of PHP 50,000)
        staticBankBranchId['189-3-167']  = 31295

        // PHP Bill Payment
        staticBankId['189-0-167']  = 21513
        staticBankBranchId['189-0-167']  = 0

        // PHP Wallet
        staticBankId['189-7-167']  = 4264
        staticBankBranchId['189-7-167']  = 0

        // PHP Gov
        staticBankId['189-8-167']  = 4520
        staticBankBranchId['189-8-167']  = 0

        //MYR BT
        staticBankId['189-1-128']  = 211
        staticBankBranchId['189-1-128']  = 20961

        //LKR BT-Collection
        staticBankId['189-1-197']  = 4207
        staticBankBranchId['189-1-197']  = 618613
        staticBankId['189-3-197']  = 4250
        staticBankBranchId['189-3-197']  = 618649

        //GBP Collection
        staticBankId['189-1-221']  = 772
        staticBankBranchId['189-1-221']  = 30949

        //VND BT-Collection
        staticBankId['189-1-228']  = 131
        staticBankBranchId['189-1-228']  = 19021
        staticBankId['189-3-228']  = 1348
        staticBankBranchId['189-3-228']  = 33292
        //VND Collection USD
        staticBankId['189-3-236']  = 1256
        staticBankBranchId['189-3-236']  = 31824

        //INR BT-Collection-UPI
        staticBankId['189-1-98']  = 2735
        staticBankBranchId['189-1-98']  = 56497
        staticBankId['189-3-98']  = 4239
        staticBankBranchId['189-3-98']  = 618606
        staticBankId['189-9-98']  = 5000
        staticBankBranchId['189-9-98']  = 0

        //BDT BT-Collection-BKash
        staticBankId['189-1-18']  = 3905
        staticBankBranchId['189-1-18']  = 618595
        staticBankId['189-3-18']  = 3905
        staticBankBranchId['189-3-18']  = 618595

        //CNY BT
        staticBankId['189-1-44']  = 1802
        staticBankBranchId['189-1-44']  = 48052

        //JPY BT
        staticBankId['189-1-106']  = 4369
        staticBankBranchId['189-1-106']  = 619109

        //KRW BT
        staticBankId['189-1-111']  = 4489
        staticBankBranchId['189-1-111']  = 619229

        //MMK BT-Collection
        staticBankId['189-1-145']  = 3982
        staticBankBranchId['189-1-145']  = 619410
        staticBankId['189-3-145']  = 3982
        staticBankBranchId['189-3-145']  = 619410

        //HKD
        staticBankId['189-1-95']  = 310
        staticBankBranchId['189-1-95']  = 24413

        //TWD
        staticBankId['189-1-205']  = 6077
        staticBankBranchId['189-1-205']  = 634537

        //USD
        staticBankId['189-1-253']  = 6084
        staticBankBranchId['189-1-253']  = 634547

        if(self.homeCountryId == 238 && dmId == 1){ //EU
          self.bankId = 1266
          self.bankBranchId = 31905
        }else if( self.homeCountryId == 221  && dmId == 1){ // UK
          self.bankId = 1345
          self.bankBranchId = 33177
        }else if( self.homeCountryId == 13  && dmId == 1){ // AU
          self.bankId = 90
          self.bankBranchId = 17721
        }else if( self.homeCountryId == 152  && dmId == 1){ // NZ
          self.bankId = 220
          self.bankBranchId = 31893
        }else if(dmId == 4){ // DOOR 2 DOOR
          if(self.homeCountryId == 167){
            self.provinceId = 167014
            self.cityId     = 167014001
          }
        }else if(dmId == 6){ // BDO CASH
          // PHP BDO Cash Card
          if(self.homeCountryId == 167){
            self.bankId = 3 // BANCO DE ORO (Metro Manila)
            self.bankBranchId = 3781
          }else if(self.homeCountryId == 18){
            self.bankId = 4255
            self.bankBranchId = 619022
          }

        }else{
          self.bankId =  staticBankId[indexTemp]
          self.bankBranchId =  staticBankBranchId[indexTemp]
        }
      },

      populateDeliveryTime(){
        const self     = this
        const currDate = new Date()
        var usedBankId       =  self.bankId
        var usedBankBranchId = self.bankBranchId

        self.deliveryTimeNumber = ""
        self.deliveryTimeType   = "-"

        if(self.deliveryMethodId == 4){
          usedBankId       =  self.provinceId
          usedBankBranchId = self.cityId
        }

        const getDeliveryTimePromise = self.$api.beneficiary.getServiceId(usedBankId, usedBankBranchId, 0, self.deliveryMethodId )  // FYI: pass country id == 0, to use correct query at ejb
        getDeliveryTimePromise.then(function(result) {
          var dtResult = result
          if(dtResult != undefined && dtResult.serviceId != undefined){

            // VALIDATE FOR INDIA && DM BT, UPI , HOME AMOUNT > 100.000
            if(self.homeCountryId == 98 && (self.deliveryMethodId == 1 || self.deliveryMethodId == 9) && parseFloat(self.homeObj.amountReal) > 100000 ){
              self.deliveryTimeType   = self.$t('general-text-business-day')
              if(currDate.getHours() >= 15){
                self.deliveryTimeNumber = self.$t('delivery-time-text-next')
              }else{
                self.deliveryTimeNumber = self.$t('general-text-same')
              }

            }else if(self.homeCountryId == 167 && self.deliveryMethodId == 1){ // VALIDATE FOR PHILIPINE && DM B2B
              if( parseFloat(self.homeObj.amountReal) <= 50000){
                self.deliveryTimeType   = self.$t('delivery-time-text-minutes')
                self.deliveryTimeNumber = 5
              }else if( parseFloat(self.homeObj.amountReal) > 50000){
                self.deliveryTimeType   = self.$t('general-text-business-day')
                if(self.bankId == 483 || self.bankId == 3	){
                  self.deliveryTimeNumber = ( currDate.getHours() <= parseInt(dtResult.cutOffTime.substring(0, 2)) ) ? self.$t('general-text-same') : self.$t('delivery-time-text-next')
                }else{
                  self.deliveryTimeNumber = self.$t('delivery-time-text-next')
                }
              }
            }else{
              self.deliveryTimeType   =  ( currDate.getHours() <= parseInt(dtResult.cutOffTime.substring(0, 2)) ) ? dtResult.estimatedDeliveryType : dtResult.newEstimatedDeliveryType
              self.deliveryTimeNumber =  ( currDate.getHours() <= parseInt(dtResult.cutOffTime.substring(0, 2)) ) ? dtResult.estimatedDeliveryTime : dtResult.newEstimatedDeliveryTime

              if(self.deliveryTimeType == "Hours" && self.deliveryTimeNumber == 1){
                self.deliveryTimeType = self.$t('delivery-time-text-Hour')
              }else if(self.deliveryTimeType == "Business Days"){
                self.deliveryTimeType   = self.$t('general-text-business-day')
                if(self.deliveryTimeNumber == 1){
                  self.deliveryTimeNumber = self.$t('delivery-time-text-next')
                }else if(self.deliveryTimeNumber < 1){
                  self.deliveryTimeNumber = self.$t('general-text-same')
                }
              }
            }

          }
        })

      },

      showErrorCard(errorMessage) {
        this.alertCard.title      = errorMessage
        this.alertCard.alertClass = 'alert-danger'
        this.alertCard.show       = true
      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      /* WA-396 */
      async updateLastFxCalcCurrencyId(currId){
        const self = this
        self.showPreloader()
        const updateLastFxCalcCurrencyIdPromise = await this.$api.customer.updateLastFxCalcCurrencyId(currId)
        
        if(updateLastFxCalcCurrencyIdPromise.status == "WN00435"){ // SUCCESS
          await self.setLastFxCalcCurrencyId(currId)
          console.log("lastFxCalcCurrencyId updateLastFxCalcCurrencyId : "+self.$store.state.customer.lastFxCalcCurrencyId)

          // RE-ARRANGE ORDER OF CURRENCIES
          const arrTxDestList = self.$store.state.customer.txDestList
          self.fxRateCountryList.forEach(function(item, i){
            arrTxDestList.forEach(function(item2){
              if(item2 === item.id){
                self.fxRateCountryList.splice(i, 1);
                self.fxRateCountryList.unshift(item);
              }
            })
          });

          self.fxRateCountryList.forEach(function(item, i){
            if(item.id === self.homeCountryId){
              self.fxRateCountryList.splice(i, 1);
              self.fxRateCountryList.unshift(item);
            }
          });
          self.hidePreloader()
        }else{ // WN00436, etc
          self.setLastFxCalcCurrencyId("0")
          self.hidePreloader()
        }

        /*
        updateLastFxCalcCurrencyIdPromise.then((res)=>{
          if(res.status == "WN00435"){ // SUCCESS
            self.setLastFxCalcCurrencyId(currId)
          }else{ // WN00436, etc
            self.setLastFxCalcCurrencyId("0")
          }
        })
        */
      },
      /* END OF WA-396 */

    }
  }
</script>